import * as TYPE from './actionType.js';

export function languageData(languageData) {
  return { type: TYPE.LANGUAGEDATA, data: languageData };
}
